import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GaEventsService {


  constructor() {

  }

  fireEvent(category: string, action: string, label: string): void {
    (<any>window).dataLayer.push({
      eventCategory: category,
      eventAction: action,
      eventLabel: label
    });
    (<any>window).dataLayer.push({ 'event': 'gaEvent' });
  }
}
